<template>
    <div class="footer">
        <img src="@/assets/yklogo2.png" alt="">
        <!-- <p>地址：北京市朝阳区金和东路20号院正大中心2号楼19-25层</p> -->
        <p>全国电话咨询热线：400-642-0148 </p>
    </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
.footer{
    width: 100%;
    height: 200px;
    background-color: #3C3A48;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
}


@media screen and (max-width: 750px) {
    .footer{
      height: auto;
      font-size: 0.5rem;
      img{
        height: 1.5rem;
        margin: .5rem;
      }
      p{
        margin: .5rem;
      }
    }
}
</style>